import { Box, Grid, Typography, TextField, Button } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/sidebar/sidebar";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  getSettingsService,
  settingService,
} from "../../services/settingService";
import useStore from "../../useStore";

const validationSchema = Yup.object().shape({
  pigmyInterest6: Yup.number().required("Required"),
  pigmyInterest12: Yup.number().required("Required"),
  pigmyInterest24: Yup.number().required("Required"),
  pigmyInterest36: Yup.number().required("Required"),
  loanInterest: Yup.number().required("Required"),
  overDueLoanInterest: Yup.number().required("Required"),
  accountOpeningFee: Yup.number().required("Required"),
});

function Settings() {
  const { setSettings } = useStore();
  const [initialValues, setInitialValues] = useState({
    pigmyInterest6: 0,
    pigmyInterest12: 0,
    pigmyInterest24: 0,
    pigmyInterest36: 0,
    loanInterest: 0,
    overDueLoanInterest: 0,
    accountOpeningFee: 0,
  });

  const getSettings = async () => {
    try {
      const response = await getSettingsService();
      console.log(response);
      setSettings(response?.settings);
      if (response?.settings) {
        setInitialValues({
          pigmyInterest6: response.settings.pigmyInterest6 || "",
          pigmyInterest12: response.settings.pigmyInterest12 || "",
          pigmyInterest24: response.settings.pigmyInterest24 || "",
          pigmyInterest36: response.settings.pigmyInterest36 || "",
          loanInterest: response.settings.loanInterest || "",
          overDueLoanInterest: response.settings.overDueLoanInterest || "",
          accountOpeningFee: response.settings.accountOpeningFee || "",
        });
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const handleSubmit = async (values) => {
    console.log("Submitted Values:", values);
    try {
      const response = await settingService(values);
      if (response.success) {
        toast.success("Settings Updated Successfully");
      }
    } catch (error) {
      toast.error("something went wrong");
    }
    // Add your API call here to save the data
  };

  //   const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setFormValues({ ...formValues, [name]: value });
  //   };

  //   const handleSubmit = async () => {
  //     try {
  //       const response = await axios.post("/api/settings", formValues);
  //       alert("Settings saved successfully!");
  //       console.log(response.data);
  //     } catch (error) {
  //       console.error("Error saving settings:", error);
  //       alert("Failed to save settings.");
  //     }
  //   };
  useEffect(() => {
    getSettings();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2, pl: 2 }}>
        <Box height={65} />
        <Typography variant="h4" sx={{ mb: 4 }}>
          Settings
        </Typography>
        {/* Interest Settings Form */}
        <Box
          sx={{
            maxWidth: "500px",
            //margin: "0 auto",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            backgroundColor: "#fff",
          }}
        >
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form>
                <Grid container spacing={3}>
                  {[
                    {
                      label: "Pigmy Interest (6 Months)",
                      name: "pigmyInterest6",
                    },
                    {
                      label: "Pigmy Interest (12 Months)",
                      name: "pigmyInterest12",
                    },
                    {
                      label: "Pigmy Interest (24 Months)",
                      name: "pigmyInterest24",
                    },
                    {
                      label: "Pigmy Interest (36 Months)",
                      name: "pigmyInterest36",
                    },
                    { label: "Loan Interest", name: "loanInterest" },
                    {
                      label: "Overdue Loan Interest",
                      name: "overDueLoanInterest",
                    },
                    {
                      label: "Account Opening Fee",
                      name: "accountOpeningFee",
                    },
                  ].map((field) => (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                      key={field.name}
                    >
                      {/* Label */}
                      <Typography
                        sx={{
                          flex: 1,
                          fontWeight: "500",
                          mr: 3,
                        }}
                      >
                        {field.label}:
                      </Typography>

                      {/* TextField */}
                      <Field
                        as={TextField}
                        name={field.name}
                        variant="outlined"
                        size="small"
                        sx={{
                          width: "50%", // This now takes effect
                        }}
                        error={
                          touched[field.name] && Boolean(errors[field.name])
                        }
                        helperText={touched[field.name] && errors[field.name]}
                      />
                    </Grid>
                  ))}

                  {/* Buttons */}
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      variant="contained"
                      color="error"
                      type="reset"
                      sx={{ width: "150px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      sx={{ width: "150px" }}
                    >
                      Save Changes
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Box>
  );
}

export default Settings;
